/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import classNames from 'classnames';
import isArray from 'lodash/isArray';
import history from 'aurora-utils/history';
import Chip from '@material-ui/core/Chip';
import { HappinessMeter } from 'aurora-section-components';
import ADGMItemDetails from 'aurora-components/ADGMItemDetails/ADGMItemDetails';
import { ADGMImage } from 'aurora-components';
import { applicationActions } from 'aurora-utils/constants';
import { keyEmptyCheck, isFeedbackProvided } from 'aurora-utils/utils';
import styles from './styles';

const SuccessScreen = props => {
  const {
    children,
    classes,
    title,
    subTitle,
    applicationNumber,
    applicationAction,
    propertyType,
    propertyAddress,
    downloadCertificatesList,
    downloadPaymentHandler,
    application,
  } = props;

  const goToPropertyHandler = () => {
    history.push('/');
  };
  const getIcon = action => {
    switch (action) {
      case applicationActions.success:
        return 'successIcon.svg';
      case applicationActions.terminate:
        return 'errorIcon.svg';
      case applicationActions.reject:
        return 'discardIcon.svg';
      default:
        return null;
    }
  };

  const getTitleColorClass = action => {
    switch (action) {
      case applicationActions.success:
        return classes.headerTitleSuccess;
      case applicationActions.terminate:
        return classes.headerTitleTerminate;
      case applicationActions.reject:
        return classes.headerTitleReject;
      default:
        return '';
    }
  };
  const isFeedbackGiven = isFeedbackProvided(
    application?.applicationDetails?.initiatorUserId,
    application?.applicationDetails?.happinessMeter,
    application?.applicationDetails?.applicationStatus,
  );
  return (
    <Container className={classes.successScreenContainer}>
      {!isFeedbackGiven && (
        <HappinessMeter
          applicationNumber={application?.applicationDetails?.applicationNumber}
          applicationId={application?.applicationDetails?.applicationId}
          applicationType={application?.applicationDetails?.applicationType}
        />
      )}
      <div className={classes.successScreenHeader}>
        {/* <Hidden smDown> */}
        <ADGMImage className={classes.successScreenHeaderImg} name={getIcon(applicationAction)} alt='status img' />
        {/* </Hidden> */}
        <div className={classes.successScreenHeaderContent}>
          <Typography
            variant='h6'
            component='h1'
            className={`${classes.successScreenHeaderTitle} ${getTitleColorClass(applicationAction)}`}
          >
            {keyEmptyCheck(title)}
          </Typography>
          {/* <Hidden mdUp> */}
          <ADGMImage className={classes.successScreenHeaderImg} name={getIcon(applicationAction)} alt='status img' />
          {/* </Hidden> */}
          {subTitle && (
            <Typography className={classes.successScreenHeaderSubTitle} variant='body1'>
              {keyEmptyCheck(subTitle)}
            </Typography>
          )}
          <Grid container spacing={2} className={classes.mt20}>
            {isArray(downloadCertificatesList) &&
              downloadCertificatesList?.map(certificate => (
                <Grid item xs={12} md={12}>
                  <Button
                    variant='body1'
                    className={classes.successScreenHeaderDownloadButton}
                    onClick={certificate?.downloadHandler}
                  >
                    <ADGMImage name='Download-Icon.svg' alt='Icon' width='16px' height='16px' />
                    {keyEmptyCheck(certificate?.title)}
                  </Button>
                </Grid>
              ))}
            {typeof downloadPaymentHandler === 'function' && (
              <Grid item xs={12} md={12}>
                <Button className={classes.successScreenHeaderDownloadButton} onClick={downloadPaymentHandler}>
                  <ADGMImage name='Download-Icon.svg' alt='Icon' width='16px' height='16px' />
                  {keyEmptyCheck('download_payment_receipt')}
                </Button>
              </Grid>
            )}
          </Grid>
        </div>
      </div>
      {applicationNumber && (
        <div className={classNames(classes.detailItemHorizontal, classes.applicationNumberContainer)}>
          <Typography className={classes.applicationNumber}>
            {keyEmptyCheck('Application_ID')}
            <span>: </span>
            <span className={classes.applicationNumberBold}>{applicationNumber}</span>
            {/* <Hidden mdUp> */}
            <span className={classes.applicationNumberIcon}>
              <svg width='12' height='13' viewBox='0 0 12 13' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M9 1.09375C9 0.828534 8.89464 0.57418 8.70711 0.386643C8.51957 0.199107 8.26522 0.09375 8 0.09375L1 0.09375C0.734784 0.09375 0.48043 0.199107 0.292893 0.386643C0.105357 0.57418 0 0.828534 0 1.09375L0 9.09375C0 9.35897 0.105357 9.61332 0.292893 9.80086C0.48043 9.98839 0.734784 10.0938 1 10.0938H4.5V4.59375C4.5 4.32853 4.60536 4.07418 4.79289 3.88664C4.98043 3.69911 5.23478 3.59375 5.5 3.59375H9V1.09375Z'
                  fill='#130F26'
                />
                <path
                  d='M11.5 5.09375H6.5C6.22386 5.09375 6 5.31761 6 5.59375V11.5938C6 11.8699 6.22386 12.0938 6.5 12.0938H11.5C11.7761 12.0938 12 11.8699 12 11.5938V5.59375C12 5.31761 11.7761 5.09375 11.5 5.09375Z'
                  fill='#130F26'
                />
              </svg>
            </span>
            {/* </Hidden> */}
          </Typography>
        </div>
      )}

      <div className={classes.successScreenMainContent}>
        <div className={classes.detailItemHorizontal}>
          <div className={classes.item}>
            <ADGMItemDetails label='Properties' value={propertyAddress} />
          </div>
          <Chip label={keyEmptyCheck(propertyType)} className={classes.propertyTypeBadge} />
        </div>
        {children}
      </div>
      <div className={classes.successScreenFooter}>
        <Button variant='contained' className={classes.successScreenFooterButton} onClick={goToPropertyHandler}>
          {keyEmptyCheck('go_to_properties')}
        </Button>
      </div>
    </Container>
  );
};

SuccessScreen.propTypes = {
  application: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  applicationNumber: PropTypes.string.isRequired,
  applicationAction: PropTypes.string.isRequired,
  propertyType: PropTypes.string.isRequired,
  propertyAddress: PropTypes.string.isRequired,
  downloadCertificatesList: PropTypes.array,
  downloadPaymentHandler: PropTypes.func,
};

SuccessScreen.defaultProps = {
  subTitle: '',
  downloadCertificatesList: [],
  downloadPaymentHandler: undefined,
};

export default withStyles(styles)(SuccessScreen);
